<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{(add) ? 'ADD BOUNDARY' : 'UPDATE BOUNDARY'}}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new p-6" :settings="settings" :key="$vs.rtl">

      <h5>{{dataName}}</h5>
      <div>
        <vs-input label="Name" v-model="dataName" class="mt-5 w-full" name="item-name"
                  v-validate="'required'"/>
        <span class="text-danger text-sm"
              v-show="errors.has('item-name')">{{ errors.first('item-name') }}</span>
      </div>
      <div>
        <vs-input label="Price" v-model="dataPrice" class="mt-5 w-full" name="item-price"
                  v-validate="'required'"/>
        <span class="text-danger text-sm"
              v-show="errors.has('item-price')">{{ errors.first('item-price') }}</span>
      </div>
      <div>
        <vs-input label="Estimated Time" v-model="estimatedTime" class="mt-5 w-full" name="item-estimated-time"
                  v-validate="'required'"/>
        <span class="text-danger text-sm"
              v-show="errors.has('item-estimated-time')">{{ errors.first('item-estimated-time') }}</span>
      </div>

      <div class="mt-5">
        <div v-if="!editZonesFlag"  class="flex flex-wrap items-right">
          <span class="zip-font-2" v-for="(item, index) in zones" :key="index">{{item}}<span v-if="index < zones.length -1">, </span></span>
        </div>
        <div class="w-full" v-else>
          <div class="mt-2 flex flex-wrap items-right" v-for="(zone_item, zone_index) in zones" :key="zone_index">
            <feather-icon icon="XIcon" @click="deleteZone(zone_item)" class="cursor-pointer "></feather-icon>
            <div class="ml-4 zip-font">{{zone_item}}</div>
          </div>
        </div>

        <div class="mt-4">
          <span v-if="!add" class="zip-font-2 w-full vs-con-input-label cursor-pointer text-primary" @click="editZones()">{{(!editZonesFlag) ? 'Edit zones' : 'Done'}}</span>
        </div>
      </div>

      <div v-if="!add" class="flex flex-wrap items-right mt-5">
        <vs-input label="New Zone" v-model="zone" class="flex-1" name="zone" />

        <vs-button class="mt-5 ml-4" type="border" color="#000" @click="addZone()">Add Zone</vs-button>

        <span class="text-danger text-sm w-full"
              v-show="errors.has('zone')">{{ errors.first('zone') }}</span>


      </div>

      <div v-else class=" mt-5">
        <span class="vs-con-input-label">Save boundary to add zones</span>
      </div>

    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    vSelect
  },
  data () {
    return {

      dataId: null,
      dataName: '',
      dataCategory: null,
      dataImg: null,
      dataOrder_status: {labell:'Select', value:-1},
      dataPrice: 0,
      restaurantId: null,
      add:false,
      zone: null,
      estimatedTime: '',
      zones: [],
      editZonesFlag: false,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (this.data.add) {
        const { add, restaurantId} = JSON.parse(JSON.stringify(this.data))
        this.initValues()

        this.add = add
        this.restaurantId = restaurantId

        this.$validator.reset()
      } else {
        const { id, add, restaurantId, name, price } = JSON.parse(JSON.stringify(this.data))
        this.initValues()
        this.dataId = id
        this.add = add
        this.restaurantId = restaurantId
        this.dataName = name
        this.dataPrice = price

        this.getBoundaryInfo()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any()
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    deleteZone (item) {
      const obj = {
        restaurantId: this.restaurantId,
        boundaryId: this.dataId,
        zipCodeId: item.id
      }
      this.$store.dispatch('api/removeZipcodeBoundary', obj).then(response => {

        if (response.data.status) {

          this.$vs.notify({
            title: 'Delete',
            text: 'Zipcode deleted succesfully',
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          })
          this.getBoundaryInfo()
        } else {

          this.$vs.notify({
            title: 'Failed!',
            text: response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          this.getBoundaryInfo()
        }
      }).catch(err => { console.error(err) })
    },
    editZones () {
      this.editZonesFlag = !this.editZonesFlag
    },
    addZone () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            boundaryId: this.dataId,
            restaurantId: this.restaurantId,
            zipCode: this.zone
          }

          this.$store.dispatch('api/setBoundaryZipcode', obj)
            .then(() => {
              this.getBoundaryInfo()
            })
            .catch(() => {
            })

        }
      })
    },
    getBoundaryInfo () {

      const boundary_info = {
        boundaryId: this.dataId,
        restaurantId: this.restaurantId
      }

      this.$store.dispatch('api/getBoundary', boundary_info)
        .then(response => {

          const { id, add, name, price, zipCodes, estimatedTime } = JSON.parse(JSON.stringify(response.data.data))
          this.initValues()
          this.dataId = id
          this.add = add
          this.dataName = name
          this.dataPrice = price
          this.zones = zipCodes
          this.estimatedTime = estimatedTime
          this.zone = ''
        })
        .catch(err => {
          console.error(err)
        })
    },
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataName = ''
      this.dataCategory = null
      this.dataOrder_status = ''
      this.estimatedTime = ''
      this.dataPrice = 0
      this.dataImg = null
      this.restaurantId = null
      this.editZonesFlag = false
      this.zones = []
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            boundaryId: this.dataId,
            restaurantId: this.restaurantId,
            boundaryName: this.dataName,
            price: this.dataPrice,
            estimatedTime: this.estimatedTime
          }

          this.$store.dispatch('api/setBoundary', obj)
            .then(() => {
              this.$emit('closeSidebar')
              this.initValues()
            })
            .catch(err => {
              console.error(err)
            })

        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
  }
  .zip-font-2 {
    font-size:18px;
  }
  .zip-font {
    font-size: 22px;
  }
</style>
